import { ProcessingNode } from '../ProcessingNode';
/**
 * @category Flow shape
 */
export class ObjectFilterNode extends ProcessingNode {
  constructor(filterFn, options) {
    super(options);
    this.options.objectFilter = this.options.objectFilter || filterFn;
  }
  process(frame) {
    return new Promise(resolve => {
      frame.getObjects().filter(object => !this.options.objectFilter(object, frame)).forEach(frame.removeObject);
      resolve(frame);
    });
  }
}